// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
import { application } from "./application"

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)

import Dashboard__BalanceSparklineController from "./dashboard/balance_sparkline_controller"
application.register("dashboard--balance-sparkline", Dashboard__BalanceSparklineController)

import DateRangeFilterController from "./date_range_filter_controller"
application.register("date-range-filter", DateRangeFilterController)

import AnchorHighlightController from "./anchor_highlight_controller"
application.register("anchor-highlight", AnchorHighlightController)

import Graphs__BalanceController from "./graphs/balance_controller"
application.register("graphs--balance", Graphs__BalanceController)

import Graphs__CostCentersController from "./graphs/cost_centers_controller"
application.register("graphs--cost-centers", Graphs__CostCentersController)

import Graphs__CostCenterPieController from "./graphs/cost_center_pie_controller"
application.register("graphs--cost-center-pie", Graphs__CostCenterPieController)

import Graphs__SparklineController from "./graphs/sparkline_controller"
application.register("graphs--sparkline", Graphs__SparklineController)

import InputMaskController from "./input_mask_controller"
application.register("input-mask", InputMaskController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import ThemeTogglerController from "./theme_toggler_controller"
application.register("theme-toggler", ThemeTogglerController)

import TransactionFormController from "./transaction_form_controller"
application.register("transaction-form", TransactionFormController)

import TurnstileController from "./turnstile_controller"
application.register("turnstile", TurnstileController)

import YearCostController from "./year_cost_controller"
application.register("year-cost", YearCostController)

import RailsNestedForm from '@stimulus-components/rails-nested-form'
application.register('nested-form', RailsNestedForm)

import ConfirmTransaction from './confirm_transaction_controller'
application.register('confirm-transaction', ConfirmTransaction)

import ModalController from "./modal_controller"
application.register("modal", ModalController)


import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import TurboConfirmController from "./turbo_confirm_controller"
application.register("turbo-confirm", TurboConfirmController)

import PropertyFormController from "./property_form_controller"
application.register("property-form", PropertyFormController)

import CepLookupController from "./cep_lookup_controller"
application.register("cep-lookup", CepLookupController)

import StateCitiesController from "./state_cities_controller"
application.register("state-cities", StateCitiesController)

import TextareAutogrowController from "./textarea_autogrow_controller"
application.register("textarea-autogrow", TextareAutogrowController)
